import { render, staticRenderFns } from "./ProjectOperations.vue?vue&type=template&id=b9cc884e&scoped=true&"
import script from "./ProjectOperations.vue?vue&type=script&lang=js&"
export * from "./ProjectOperations.vue?vue&type=script&lang=js&"
import style0 from "./ProjectOperations.vue?vue&type=style&index=0&id=b9cc884e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9cc884e",
  null
  
)

export default component.exports